import React from 'react';
import PropTypes from 'prop-types';

const KPIs = ({ children }) => (
  <div className="kpi-container info-block">
    <div className="flex-container spread-items">{children}</div>
  </div>
);

KPIs.propTypes = {
  /** contains 0..n KPI */
  children: PropTypes.node.isRequired,
};

export default KPIs;
